var imageBlobReduce = require('node_modules/image-blob-reduce/dist/image-blob-reduce.min.js')

angular.module("core").constant(
    "imageBlobReduce", imageBlobReduce
);



//////////////////
// WEBPACK FOOTER
// ./core/image-blob-reduce/image-blob-reduce.constant.js
// module id = 374
// module chunks = 0